const URL = '/transferencias';

const state = {
  edited: {
    id: null,
    cuenta_origen_id: null,
    cuenta_destino_id: null,
    importe: 0,
    cantidad: 0,
    detalle: null,
  },
  cuenta: {
    id: null,
    documento: null,
    razon_social: null,
    numero: null,
    descripcion: null,
  },
  loading: false,
  rules: {
    cuenta_origen_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una cuenta origen asociada',
    ],
    cuenta_destino_id: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe existir una cuenta destino asociada',
    ],
    importe: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a cero (0)',
    ],
    cantidad: [
      v => !!v || 'Este campo es necesario',
      v => v > 0 || 'Debe ser mayor a cero (0)',
    ],
    detalle: [
      // v => !!v || 'Este campo es necesario',
    ],
  },
}

// GETTERS
const getters = {
  edited(state) {
    return state.edited
  },
  cuenta(state) {
    return state.cuenta
  },
  loading(state) {
    return state.loading
  },
  rules(rootGetters) {
    // Obtener saldo_subsidio de la cuenta origen desde el store de Cuentas
    const cuentaOrigen = rootGetters['Cuentas/selected']
    const saldoSubsidioOrigen = cuentaOrigen && cuentaOrigen.saldo_subsidio ? cuentaOrigen.saldo_subsidio : 0

    return {
      cuenta_origen_id: [
        v => !!v || 'Este campo es necesario',
        v => v > 0 || 'Debe existir una cuenta origen asociada',
      ],
      cuenta_destino_id: [
        v => !!v || 'Este campo es necesario',
        v => v > 0 || 'Debe existir una cuenta destino asociada',
      ],
      importe: [
        v => (v !== null && v !== '' && v !== undefined) || 'Este campo es necesario',
        v => parseFloat(v) > 0 || 'Debe ser mayor a 0,00',
        v => parseFloat(v) <= saldoSubsidioOrigen || `El importe no puede superar el saldo de subsidio ($${saldoSubsidioOrigen.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })})`,
      ],
      cantidad: [
        v => (v !== null && v !== '' && v !== undefined) || 'Este campo es necesario',
        v => parseFloat(v) > 0 || 'Debe ser mayor a 0,00',
      ],
    }
  },
}

// ACTIONS
const actions = {
  onClearEdited({ commit }) {
    commit('setEdited', {
      id: null,
      cuenta_origen_id: null,
      cuenta_destino_id: null,
      importe: 0,
      cantidad: 0,
      detalle: null,
    })
  },
  onClearCuenta({ commit }) {
    commit('setCuenta', {
      id: null,
      documento: null,
      razon_social: null,
      numero: null,
      descripcion: null,
    })
  },
  onSave({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, {
        cuenta_origen_id: state.edited.cuenta_origen_id,
        cuenta_destino_id: state.edited.cuenta_destino_id,
        importe: state.edited.importe,
        cantidad: state.edited.cantidad,
        detalle: state.edited.detalle,
      })
        .then(response => {
          commit('ResponseHTTP/addSuccess', 'Transferencia realizada', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se realizo la transferencia', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setEdited(state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setCuenta(state, payload) {
    state.cuenta = Object.assign({}, payload)
  },
  setLoading(state, payload) {
    state.loading = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
